export default {
    searchBy: 'Search by Special Workday Name',
    search: 'Search',
    addSpecialWorkday: 'Add Special Work Day',
    specialWorkdayName: 'Name',
    workDay: 'Work Date',
    dateCreate: 'Date Create',
    startEndTime: 'Start - End Time',
    description: 'Description',
    forGroup: 'For Group',
    deleteGroup: 'Delete Special Workday',
    congratulation: 'Congratulation',
    msgDeleteSuccess: 'Special Workday is deleted.',
    questionDelete: 'Are you sure to delete "$Name" special workday?'
}
